import React from 'react';
import { FaCheckCircle } from 'react-icons/fa'; // You can add other icons as needed
import '../styles/five.css';
const ProfessionalSummary = () => {

  return (
    <section className="resume">
    <div className="container">
      <div className="section-title">
        <h2 className="fw-bold text-dark">Professional Experience</h2>
        <hr />
      </div>
      <div className="row">
        {/* Left Column */}
        <div className="col-lg-6" data-aos="fade-up">
          <div className="resume-item pb-0">
            <h4 className="px-3 fw-bold text-start text-primary">Quantum Applications & Algorithms </h4>
            <ul className="px-3 text-start text-dark">
              <li>
                <FaCheckCircle className="text-success" />
                Applied <strong>Machine Learning</strong> algorithms and geospatial tools to optimize energy exploration using <strong>Python, MATLAB, ArcGIS, QGIS, AWS Quantum (Qubits)</strong>, and <strong>Google Cloud AI</strong>.
              </li>
              <li>
                <FaCheckCircle className="text-success" />
                Utilized predictive modeling for accurate site identification by integrating geophysical data and satellite imagery.
              </li>
            </ul>
          </div>
          <div className="resume-item pb-0">
            <h4 className="px-3 fw-bold text-start text-primary">Data Science & Big Data Engineering</h4>
            <ul className="px-3 text-start text-dark">
              <li>
                <FaCheckCircle className="text-success" />
                Developed <strong>ETL/ELT</strong> pipelines to integrate large datasets, enhancing analysis in data lakes using <strong>Python, R, SQL, Cassandra, Hadoop, Spark</strong>.
              </li>
              <li>
                <FaCheckCircle className="text-success" />
                Implemented machine learning models for predictive analytics and statistical insights; proficient in <strong>TensorFlow, Scikit-Learn</strong>.
              </li>
              <li>
                <FaCheckCircle className="text-success" />
                Created data visualizations with <strong>Tableau, Power BI, Seaborn</strong>, deployed via <strong>Docker, Kubernetes, AWS</strong>.
              </li>
            </ul>
          </div>
          <div className="resume-item pb-0">
            <h4 className="px-3 fw-bold text-start text-primary">UI/UX & System Design</h4>
            <ul className="px-3 text-start text-dark">
              <li>
                <FaCheckCircle className="text-success" />
                Designed wireframes and prototypes in <strong>Figma, Adobe XD</strong> for enhanced user accessibility and experience.
              </li>
              <li>
                <FaCheckCircle className="text-success" />
                Expert in system architecture for web and mobile apps, proficient in <strong>LLD, HLD</strong> using <strong>UML, Draw.io, Wondershare Edraw Max</strong>.
              </li>
            </ul>
          </div>
          <div className="resume-item pb-0">
            <h4 className="px-3 fw-bold text-start text-primary">Cloud & DevOps Engineering</h4>
            <ul className="px-3 text-start text-dark">
              <li>
                <FaCheckCircle className="text-success" />
                Architected and managed cloud infrastructure on <strong>AWS, Google Cloud, Azure</strong>, ensuring operational efficiency and scalability.
              </li>
              <li>
                <FaCheckCircle className="text-success" />
                Skilled in DevOps tools and practices, including <strong>Jenkins, Git, GitHub Actions, Terraform</strong>, for CI/CD and infrastructure automation.
              </li>
            </ul>
          </div>
          <div className="resume-item pb-0">
  <h4 className="px-3 fw-bold text-start text-primary">Mobile App Development</h4>
  <ul className="px-3 text-start text-dark">
  <li>
  <FaCheckCircle className="text-success" />
  Developed high-performance mobile applications on <strong>Android</strong>, leveraging <strong>Flutter, Dart, Kotlin,</strong> and <strong>Swift</strong> for cross-platform solutions that ensure optimal functionality and seamless user experiences.
</li>

    
    <li>
      <FaCheckCircle className="text-success" />
      Implemented best practices in <strong>Mobile  UI/UX design </strong>, focusing on responsive layouts, intuitive navigation, and accessibility to enhance user engagement and satisfaction.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Experienced in integrating RESTful APIs and third-party services, enabling dynamic data interaction and real-time functionality within mobile applications.
    </li>
    
  </ul>
</div>
<div className="resume-item pb-0">
  <h4 className="px-3 fw-bold text-start text-primary">Scrum & Agile Methodologies</h4>
  <ul className="px-3 text-start text-dark">
    <li>
      <FaCheckCircle className="text-success" />
      Skilled in Agile methodologies, contributing to sprint planning, backlog refinement, and team efficiency using tools like <strong>Jira,Trello, Confluence </strong>.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Facilitated effective communication and collaboration within cross-functional teams, ensuring alignment on project goals and timely delivery of high-quality results.
    </li>
  </ul>
</div>

        </div>
        {/* Right Column */}
        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
        <div className="resume-item pb-0">
  <h4 className="px-3 fw-bold text-start text-primary">Full Stack Development</h4>
  <ul className="px-3 text-start text-dark">
    <li>
      <FaCheckCircle className="text-success" />
      Dynamic and results-driven Full Stack Developer with over 4 years of experience delivering innovative software solutions and optimizing user experience through well-architected, scalable applications.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Proficient in a wide range of front-end and back-end technologies, including <strong>  JavaScript, ReactJS, Flutter, Cargo, Tauri, Actix-Web, Go-Fiber, Yew, Spring Boot, Django, Angular, HTML5, CSS3, and responsive UI frameworks like Bootstrap 4 & 5</strong>.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Skilled in server-side development with <strong>  Node.js, Express.js, Java, Dart, Swift, Rust, Golang, and Python</strong> along with hands-on expertise in databases like <strong> MongoDB, MySQL, PostgreSQL, DynamoDB, Neo4J, and SurrealDB</strong> .
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Demonstrated experience with cloud platforms (AWS, Google Cloud) and containerization (Docker), as well as CI/CD pipelines and DevOps tools, ensuring efficient and reliable deployment processes.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Recognized for proficiency in Agile methodologies and a collaborative, solutions-oriented mindset, with a strong ability to design, implement, and maintain full-stack applications that meet both technical and business requirements.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Actively engaged in exploring advanced concepts in machine learning and AI, contributing to cutting-edge project innovations.
    </li>
  </ul>
</div>


          <div className="resume-item pb-0">
  <h4 className="px-3 fw-bold text-start text-primary">Problem-Solving & Analytical Skills</h4>
  <ul className="px-3 text-start text-dark">
    <li>
      <FaCheckCircle className="text-success" />
      Proficiency in solving complex technical challenges by applying structured methodologies, such as Root Cause Analysis, algorithmic optimization, and mathematical modeling. Skilled in identifying core issues and implementing effective solutions that enhance system performance and operational efficiency across diverse projects.
    </li>
    
    <li>
      <FaCheckCircle className="text-success" />
      Strong proficiency in <strong>Data Structures and Algorithms (DSA) </strong>  across multiple programming languages, including <strong> Python, Java, and C++, </strong> enabling effective problem-solving and efficient code execution and implementing <strong> OOPS Concepts </strong> for Better performance and optimisation.
    </li>
    
    <li>
      <FaCheckCircle className="text-success" />
      Applied advanced data analysis techniques to uncover root causes, deliver actionable insights, and drive informed decision-making.
    </li>
    
    <li>
      <FaCheckCircle className="text-success" />
      Consistently improved productivity and efficiency by breaking down complex problems into manageable tasks and implementing strategic, data-driven solutions.
    </li>
  </ul>
</div>


<div className="resume-item pb-0">
  <h4 className="px-3 fw-bold text-start text-primary">Version Control & Source Code Management</h4>
  <ul className="px-3 text-start text-dark">
    <li>
      <FaCheckCircle className="text-success" />
      Proficient in <strong>Git, GitHub, GitLab, BitBucket, Jenkins, and Ansible</strong> for source control, code review, and continuous integration workflows.
    </li>
    <li>
      <FaCheckCircle className="text-success" />
      Experienced in designing and managing <strong>CI/CD pipelines</strong> with tools like Jenkins, GitLab CI/CD, and Docker, ensuring streamlined and automated deployment processes.
    </li>
  </ul> 
</div>

        </div>
      </div>
    </div>
  </section>
  
  
  );
};

export default ProfessionalSummary;

// import React from 'react';
// import { FaCheckCircle } from 'react-icons/fa'; // You can add other icons as needed
// import '../styles/five.css';

// const ProfessionalSummary = () => {
//   return (
//     <section id="professional" className="summary-section">
//       <div className="summary-container">
//         <div className="summary-header">
//           <h1 className="summary-title">Professional Experience</h1>
//           <hr />
//         </div>
//         <div className="row">
//           {/* Left Column */}
//           <div className="col-lg-6" data-aos="fade-up">
//             <div className="summary-item">
//               <h3 className="item-subtitle">Full Stack Proficiency:</h3>
//               <ul className="item-list">
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> 4+ years of experience in innovative application/software development with a strong foundation in SDLC and problem-solving, proficient in multiple programming languages and development tools.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> 3+ years of experience in full-stack development, Agile methodologies, and software testing; proven ability to design and implement scalable, efficient software solutions while staying up to date with emerging technologies.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Proficient in financial software & tools, including Data Intelligence tools that support strategic decision-making; strong analytical skills with the ability to identify cost-saving opportunities.
//                 </li>
//               </ul>
//             </div>

//             <div className="summary-item">
//               <h6 className="item-subtitle">Testing and Quality Assurance:</h6>
//               <ul className="item-list">
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Commitment to delivering bug-free code through rigorous testing practices.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Proficient in various testing frameworks and methodologies, ensuring the reliability and robustness of applications.
//                 </li>
//               </ul>
//             </div>

//             <div className="summary-item">
//               <h6 className="item-subtitle">Agile Development:</h6>
//               <ul className="item-list">
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Adaptability and flexibility in Agile development environments, thriving in fast-paced settings.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Experience in sprint planning, daily stand-ups, and continuous improvement processes.
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Right Column */}
//           <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
//             <div className="summary-item">
//               <h6 className="item-subtitle">Data Science/Analysis Skills:</h6>
//               <ul className="item-list">
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Proficient in Data Engineering with a proven track record of transforming raw data into actionable insights.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Skilled in various data science tools and programming languages, including Python, R, SQL, and Cassandra-DB.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Expertise in machine learning algorithms for predictive modeling and statistical analysis.
//                 </li>
//               </ul>
//             </div>

//             <div className="summary-item">
//               <h6 className="item-subtitle">UI/UX Design:</h6>
//               <ul className="item-list">
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Lead in the design of wireframes, prototypes, and graphics for user-centered designs.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Supervising assessment to ensure quality and accuracy of design.
//                 </li>
//                 <li className="item-list-entry">
//                   <FaCheckCircle className="icon-check" /> Innovative and deadline-driven Graphic Designer with 3+ years of experience.
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProfessionalSummary;

